// noinspection DuplicatedCode

import React, { useEffect, useState } from "react";

import { Colors } from "../../../../assets/Colors";
import { fetchGet, fetchPost, fetchPut } from "../../../../fetchers";
import { useMutation, useQuery } from "@tanstack/react-query";
import { DynamicTableExtend } from "../../../../components/tablecard/DynamicTable";
import { Card } from "@material-tailwind/react";
import {
  isRequired,
  useForm,
  validate,
} from "../../../../components/isRequired";
import Modal from "@material-tailwind/react/Modal";
import ModalHeader from "@material-tailwind/react/ModalHeader";
import ModalBody from "@material-tailwind/react/ModalBody";
import { HrdInputGenerator } from "../../../../components/form/HrdInputGenerator";
import ModalFooter from "@material-tailwind/react/ModalFooter";
import Button from "@material-tailwind/react/Button";
import "react-toastify/dist/ReactToastify.css";
import { maxPageGlobal } from "../../../../assets/config";
import { toast } from "react-toastify";
import NumberFormat from "react-number-format";
import { downloadExcel } from "react-export-table-to-excel";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

const SaldoAwal = ({}) => {
  const monthOptions = [
    { value: "1", label: "Januari" }, { value: "2", label: "Februari" },
    { value: "3", label: "Maret" },   { value: "4", label: "April" },
    { value: "5", label: "Mei" },     { value: "6", label: "Juni" },
    { value: "7", label: "Juli" },    { value: "8", label: "Agustus" },
    { value: "9", label: "September"},{ value: "10", label: "Oktober" },
    { value: "11", label: "November"},{ value: "12", label: "Desember" },
  ];
  const yearOptions = Array.from({ length: 11 }, (_, i) => String(2020 + i));

  let initialState = {
    BisnisUnit: "U0001",
    mainaccount: "",
    subaccount: "",
    detailaccount: "",
    Bulan: "12",
    Tahun: "2022",
  };
  const validations = [
    ({ Saldo }) =>
      (Saldo !== undefined && Saldo !== null && Saldo !== "") || { Saldo: "Saldo wajib diisi" },
  ];
  const [buttonTouched, setButtonTouched] = useState(false);

  const {
    changed,
    values,
    isValid,
    touched,
    clearHandler,
    submitHandler,
    customHandler,
    changeHandler,
    errors,
    editHandler,
  } = useForm(initialState, validations);
  const [search, setSearch] = useState("");
  const [dataUpkeep, setdataUpkeep] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [detail, setDetail] = useState({});
  const [count, setCount] = useState(maxPageGlobal);
  const [start, setStart] = useState(0);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [maxPage, setMaxPage] = useState(0);
  const [param, setParam] = useState({
    start: start,
    count: count,
    search: "",
    BisnisUnit: "U0001",
    mainaccount: "",
    subaccount: "",
    detailaccount: "",
    Bulan: "12",
    Tahun: "2022",
  });
  
  // Fetch BisnisUnit options
  const { data: bisnisUnitData } = useQuery({
    queryKey: ['bisnisUnit'],
    queryFn: () => fetchGet('getMinMasterBisnisUnit'),
    staleTime: 5 * 60 * 1000,
  });
  
  const mutationData = useMutation((param) =>
    fetchGet(
      "Accounting/SaldoAwal/" +
        param.BisnisUnit +
        "/" +
        param.mainaccount +
        "/" +
        param.subaccount +
        "/" +
        param.detailaccount +
        "?bulan=" + (param.Bulan || "12") +
        "&tahun=" + (param.Tahun || "2022")
    )
  );
  const mutationEdit = useMutation(
    (formData) => fetchPut("Accounting/SaldoAwal/", formData),
    {
      onError: (error) => {
        toast.error("Gagal menyimpan data: " + (error.message || "Terjadi kesalahan"));
      },
      onSettled: () => {
        // Mutation completed (success or error)
      },
    }
  );
  const [detailModal, setDetailModal] = useState({});
  const [showModalEdit, setShowModalEdit] = useState(false);
  const [showKonfirmasi, setShowKonfirmasi] = useState(false);
  const [pendingSubmit, setPendingSubmit] = useState(null);
  const [riwayatSeed, setRiwayatSeed] = useState([]);

  const mutationRiwayat = useMutation((param) =>
    fetchGet("Accounting/SaldoAwalRiwayat/" + param.bisnisUnit + "/" + param.detailAccountID)
  );

  useEffect(() => {
    toast.info("Loading table!", {
      position: "top-center",
      autoClose: 1000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: false,
      draggable: true,
      theme: "light",
    });

    mutationData.mutate(param);
  }, [param]);

  const filterApi = () => {
    setParam({
      start: start,
      count: count,
      search: "",
      BisnisUnit: values.BisnisUnit,
      mainaccount: values.mainaccount,
      subaccount: values.subaccount,
      detailaccount: values.detailaccount,
      Bulan: values.Bulan || "12",
      Tahun: values.Tahun || "2022",
    });
  };
  const header = [
    { name: "Bisnis Unit", key: "NamaBisnisUnit", modifiers: "Text" },
    { name: "Account", key: "KetAccount", modifiers: "Text" },
    { name: "Detail Account", key: "DetailAccount", modifiers: "Text" },
    { name: "Saldo", key: "Saldo", modifiers: "Number " },
    { name: "Edit", key: "Edit", modifiers: "Button" },
  ];
  const customHandlers = (event) => {
    const newValues = {
      ...detailModal,
      ["Saldo"]: event.floatValue?.toString() || "",
    };
    const { isValid, errors } = validate(validations, newValues);
    setDetailModal(newValues);
  };

  const handleModalBisnisUnit = (value, name) => {
    const selectedBiz = bisnisUnitData?.data?.find(item => item.value === value);
    const newValues = {
      ...detailModal,
      ["BisnisUnit"]: value,
      ["NamaBisnisUnit"]: selectedBiz?.label || value,
    };
    setDetailModal(newValues);
  };

  const inputBuilder = [
    {
      type: "BisnisUnit",
      name: "BisnisUnit",
      title: "Bisnis Unit",
      handler: handleModalBisnisUnit,
      size: "full",
      required: true,
      disabled: false,
      edit: true,
    },
    {
      type: "text",
      name: "KetAccount",
      title: "Account",
      handler: changeHandler,
      size: "full",
      required: false,
      disabled: true,
      edit: true,
    },
    {
      type: "text",
      name: "DetailAccount",
      title: "Detail Account",
      handler: changeHandler,
      size: "full",
      required: false,
      disabled: true,
      edit: true,
    },
    {
      type: "numberFormatSatu",
      name: "Saldo",
      title: "Saldo",
      handler: customHandlers,
      size: "full",
      required: true,
      disabled: false,
      edit: false,
    },
  ];

  const filterData = (event) => {
    const filtered = mutationData.data.filter(({ NamaKaryawan }) =>
      NamaKaryawan.toLowerCase().includes(event.target.value.toLowerCase())
    );
    setdataUpkeep(filtered);
  };

  const ModalOpener = (detail) => {
    setShowModal(!showModal);
    setDetail(detail);
  };

  function handleUpdatePage(newPage) {
    let newStart = newPage * count - count;

    setParam({
      start: newStart,
      count: count,
      search: "",
    });
  }

  function handleUpdateCount(newCount) {
    let calc = count - 1;
    if (calc === 0) {
      calc = 1;
    }
    setParam({
      start: parseInt(newCount === "-1" ? 0 : start),
      count: parseInt(newCount === "-1" ? count : newCount),
      search: search,
    });
    setPage(newCount === "-1" ? 0 : start);
    setStart(newCount === "-1" ? count : newCount);
    setSearch(search);
    setPage(1);
    setCount(newCount === "-1" ? count : newCount);
    setStart(newCount === "-1" ? 0 : start);
    setMaxPage(newCount === "-1" ? 1 : Math.ceil(calc / newCount));
  }

  function handleModal(value) {
    const baseData = !value.AccountBalanceID && Object.keys(value).length === 0
      ? { AccountBalanceID: "", BisnisUnit: "", NamaBisnisUnit: "", KetAccount: "", DetailAccount: "", Saldo: "" }
      : { ...value };

    const modalData = {
      ...baseData,
      Bulan: param.Bulan || "12",
      Tahun: param.Tahun || "2022",
    };
    setDetailModal(modalData);
    setRiwayatSeed([]);
    setShowKonfirmasi(false);
    setShowModal(true);
    setShowModalEdit(true);

    // Ambil riwayat seed untuk akun ini
    if (baseData.DetailAccount) {
      const detailID = baseData.DetailAccount.split(" - ")[0]?.trim();
      const bisnisUnit = baseData.BisnisUnit || param.BisnisUnit || "U0001";
      if (detailID) {
        mutationRiwayat.mutate(
          { bisnisUnit, detailAccountID: detailID },
          { onSuccess: (res) => setRiwayatSeed(res?.data || []) }
        );
      }
    }
  }

  // Export Excel / PDF (mengikuti pola Trial Balance).
  const exportHeader = ["Bisnis Unit", "Account", "Detail Account", "Saldo"];
  const fmtSaldo = (val) =>
    Math.round(parseFloat(val || 0)).toLocaleString("id-ID", { maximumFractionDigits: 0 });
  const periodeLabel = (param.Bulan || "12") + "-" + (param.Tahun || "2022");
  const buildExportRows = () => {
    const source = mutationData.data?.data || [];
    const rows = source.map((row) => [
      row.NamaBisnisUnit || row.BisnisUnit || "",
      row.KetAccount || "",
      row.DetailAccount || "",
      fmtSaldo(row.Saldo),
    ]);
    const grandTotal = source.reduce((sum, row) => sum + parseFloat(row.Saldo || 0), 0);
    rows.push(["Grand Total", "", "", fmtSaldo(grandTotal)]);
    return rows;
  };

  const handleDownloadExcel = () => {
    if ((mutationData.data?.data || []).length === 0) {
      toast.info("Tidak ada data untuk diexport");
      return;
    }
    const rows = buildExportRows();
    downloadExcel({
      fileName: "SaldoAwal_" + periodeLabel,
      sheet: "Saldo Awal",
      tablePayload: { header: exportHeader, body: rows },
    });
  };

  const handleDownloadPDF = () => {
    if ((mutationData.data?.data || []).length === 0) {
      toast.info("Tidak ada data untuk diexport");
      return;
    }
    const rows = buildExportRows();
    const doc = new jsPDF({ orientation: "landscape" });
    doc.setFontSize(14);
    doc.text("Saldo Awal", 14, 15);
    doc.setFontSize(10);
    doc.text("Periode: " + periodeLabel, 14, 22);
    autoTable(doc, {
      startY: 28,
      head: [exportHeader],
      body: rows,
      styles: { fontSize: 8, cellPadding: 2 },
      headStyles: { fillColor: [41, 128, 185], textColor: 255, fontStyle: "bold" },
      didParseCell: (data) => {
        if (data.column.index === 3) data.cell.styles.halign = "right";
        const isLast = data.row.index === rows.length - 1;
        if (isLast) {
          data.cell.styles.fontStyle = "bold";
          data.cell.styles.fillColor = [93, 173, 226];
          data.cell.styles.textColor = [255, 255, 255];
        }
      },
    });
    doc.save("SaldoAwal_" + periodeLabel + ".pdf");
  };

  return (
    <div className="md:ml-64">
      <div
        style={{ background: Colors.primary }}
        className="pt-14 pb-16 px-3 md:px-8 h-auto"
      >
        <div className="container mx-auto max-w-full">
          <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-4"></div>
        </div>
      </div>
      <div className="px-3 md:px-8 h-auto -mt-32">
        <div className="container mx-auto max-w-full">
          <div className="grid grid-cols-1 px-4">
            <Card>
              <div className="flex flex-row flex-wrap items-start justify-start w-full px-2 py-2">
                <div className={"w-1/4"}>
                  <HrdInputGenerator
                    type={"BisnisUnit"}
                    name={"BisnisUnit"}
                    title={"BisnisUnit"}
                    value={values}
                    required={true}
                    includeAll={true}
                    onChange={customHandler}
                    touched={touched}
                    errors={errors}
                    size={"full"}
                  />
                </div>
                <div className={"w-1/4"}>
                  <HrdInputGenerator
                    type={"mainAccount"}
                    name={"mainaccount"}
                    title={"Main Account"}
                    value={values}
                    required={true}
                    onChange={customHandler}
                    touched={touched}
                    errors={errors}
                    size={"full"}
                  />
                </div>
                <div className={"w-1/6 px-1"}>
                  <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                    Bulan
                  </label>
                  <select
                    value={values.Bulan || "12"}
                    onChange={(e) => customHandler({ target: { name: "Bulan", value: e.target.value } })}
                    className="block w-full bg-white border border-gray-300 text-gray-700 text-sm rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-300"
                  >
                    {monthOptions.map((m) => (
                      <option key={m.value} value={m.value}>{m.label}</option>
                    ))}
                  </select>
                </div>
                <div className={"w-1/6 px-1"}>
                  <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                    Tahun
                  </label>
                  <select
                    value={values.Tahun || "2022"}
                    onChange={(e) => customHandler({ target: { name: "Tahun", value: e.target.value } })}
                    className="block w-full bg-white border border-gray-300 text-gray-700 text-sm rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-300"
                  >
                    {yearOptions.map((y) => (
                      <option key={y} value={y}>{y}</option>
                    ))}
                  </select>
                </div>
                <div className={"w-1/6 px-1 flex items-end"}>
                  <div>
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                      Buka data
                    </label>
                    <button
                      type="button"
                      onClick={filterApi}
                      className="text-main-100 hover:text-white border border-main-100 hover:bg-main-100 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2 text-center mr-2 mb-2"
                    >
                      Buka
                    </button>
                  </div>
                </div>
              </div>
              <div className="flex flex-row gap-2 px-2 pb-2">
                <button
                  type="button"
                  onClick={handleDownloadExcel}
                  className="flex flex-row items-center justify-center my-2 sm:my-0 bg-white text-gray-800 font-semibold py-2 px-4 border border-green-600 hover:bg-green-600 hover:text-white rounded shadow"
                >
                  Download Excel
                </button>
                <button
                  type="button"
                  onClick={handleDownloadPDF}
                  className="flex flex-row items-center justify-center my-2 sm:my-0 bg-white text-gray-800 font-semibold py-2 px-4 border border-red-500 hover:bg-red-500 hover:text-white rounded shadow"
                >
                  Download PDF
                </button>
              </div>
              <div className="flex flex-col items-center content-center ">
                <DynamicTableExtend
                  data={mutationData.data}
                  header={header}
                  menuController={filterData}
                  Master={true}
                  currentPage={page}
                  maxPage={maxPage}
                  name={"Saldo Awal"}
                  OnClick={ModalOpener}
                  updateCount={handleUpdateCount}
                  count={count}
                  updatePage={handleUpdatePage}
                  modal={handleModal}
                />
              </div>
            </Card>
            <Modal
              size="lg"
              active={showModal}
              toggler={() => {
                setShowModal(true);
              }}
            >
              <ModalHeader
                className="mt-20"
                toggler={() => {
                  setShowModal(false);
                  setShowModalEdit(false);

                  clearHandler();
                }}
              >
                {showModalEdit ? "Edit Data" : "Tambah Data"}
              </ModalHeader>
              <ModalBody>
                {!showKonfirmasi ? (
                  <>
                    <form className="w-full" onSubmit={submitHandler}>
                      {inputBuilder.map(({ type, name, title, handler, modifiers, size, required, disabled, edit }, id) => {
                        if (!edit || showModalEdit) {
                          return (
                            <HrdInputGenerator
                              key={id} type={type} value={detailModal} name={name} title={title}
                              onChange={handler} touched={touched} buttonTouched={buttonTouched}
                              modifiers={modifiers} size={size} required={required} errors={errors} disabled={disabled}
                            />
                          );
                        }
                      })}
                    </form>

                    {/* Riwayat Seed */}
                    <div className="mt-4 border-t pt-3">
                      <p className="text-xs font-bold uppercase text-gray-500 mb-2">
                        Riwayat Titik Acuan (Seed) Akun Ini
                      </p>
                      {mutationRiwayat.isLoading ? (
                        <p className="text-xs text-gray-400">Memuat riwayat...</p>
                      ) : riwayatSeed.length === 0 ? (
                        <p className="text-xs text-gray-400 italic">Belum ada seed yang tersimpan.</p>
                      ) : (
                        <table className="w-full text-xs border border-gray-200 rounded">
                          <thead className="bg-gray-50">
                            <tr>
                              <th className="text-left px-2 py-1 text-gray-600">Periode</th>
                              <th className="text-right px-2 py-1 text-gray-600">Saldo</th>
                              <th className="text-left px-2 py-1 text-gray-600">Berlaku untuk</th>
                            </tr>
                          </thead>
                          <tbody>
                            {riwayatSeed.map((r, i) => {
                              const nextBulan = parseInt(r.Bulan) === 12 ? 1 : parseInt(r.Bulan) + 1;
                              const nextTahun = parseInt(r.Bulan) === 12 ? parseInt(r.Tahun) + 1 : parseInt(r.Tahun);
                              const isActive = i === 0;
                              return (
                                <tr key={i} className={isActive ? "bg-green-50" : ""}>
                                  <td className="px-2 py-1">{r.Bulan}/{r.Tahun}{isActive && <span className="ml-1 text-green-600 font-bold">(aktif)</span>}</td>
                                  <td className="px-2 py-1 text-right font-mono">{r.Saldo}</td>
                                  <td className="px-2 py-1 text-gray-500">Mulai {nextBulan}/{nextTahun}</td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </table>
                      )}
                    </div>
                  </>
                ) : (
                  /* Konfirmasi Dialog */
                  <div className="py-2">
                    <div className="flex items-center gap-2 mb-3">
                      <span className="text-yellow-500 text-2xl">⚠</span>
                      <p className="font-semibold text-gray-800">Konfirmasi Penyimpanan Saldo Awal</p>
                    </div>
                    <div className="bg-yellow-50 border border-yellow-200 rounded p-3 mb-3 text-sm text-gray-700">
                      <p>Saldo <strong>{pendingSubmit?.Saldo}</strong> untuk periode <strong>{pendingSubmit?.Bulan}/{pendingSubmit?.Tahun}</strong> akan disimpan.</p>
                      <p className="mt-1">
                        Laporan Buku Bank mulai bulan{" "}
                        <strong>
                          {parseInt(pendingSubmit?.Bulan) === 12 ? 1 : parseInt(pendingSubmit?.Bulan) + 1}/
                          {parseInt(pendingSubmit?.Bulan) === 12 ? parseInt(pendingSubmit?.Tahun) + 1 : pendingSubmit?.Tahun}
                        </strong>{" "}
                        dan seterusnya akan menggunakan nilai ini sebagai modal awal.
                      </p>
                    </div>
                    <p className="text-xs text-gray-500">Periode sebelumnya tidak terpengaruh. Pastikan nilai ini sudah benar sebelum melanjutkan.</p>
                  </div>
                )}
              </ModalBody>
              <ModalFooter>
                <Button
                  color="red"
                  buttonType="link"
                  onClick={() => {
                    setShowModal(false);
                    setShowModalEdit(false);
                    setShowKonfirmasi(false);
                    setPendingSubmit(null);
                    clearHandler();
                  }}
                  ripple="dark"
                >
                  {showKonfirmasi ? "Batal" : "Cancel"}
                </Button>

                {!showKonfirmasi ? (
                  <Button
                    color="blue"
                    onClick={() => {
                      const submitData = {
                        ...detailModal,
                        AccountBalanceID: detailModal.AccountBalanceID || "",
                        BisnisUnit: detailModal.BisnisUnit || "",
                        NamaBisnisUnit: detailModal.NamaBisnisUnit || detailModal.BisnisUnit || "",
                        KetAccount: detailModal.KetAccount || "",
                        DetailAccount: detailModal.DetailAccount || "",
                        Saldo: detailModal.Saldo || "0",
                        Bulan: detailModal.Bulan || param.Bulan || "12",
                        Tahun: detailModal.Tahun || param.Tahun || "2022",
                      };
                      console.log("[SaldoAwal] submitData:", submitData);
                      if (!submitData.BisnisUnit && !submitData.NamaBisnisUnit) {
                        toast.error("Bisnis Unit wajib dipilih!");
                        return;
                      }
                      const { isValid: isDetailValid } = validate(validations, submitData);
                      if (!isDetailValid) {
                        setButtonTouched(true);
                        toast.error("Harap lengkapi data yang diperlukan!");
                        return;
                      }
                      setPendingSubmit(submitData);
                      setShowKonfirmasi(true);
                    }}
                    ripple="light"
                  >
                    Simpan
                  </Button>
                ) : (
                  <Button
                    color="green"
                    disabled={mutationEdit.isLoading}
                    onClick={() => {
                      mutationEdit.mutate(pendingSubmit, {
                        onSuccess: () => {
                          setShowModal(false);
                          setShowModalEdit(false);
                          setShowKonfirmasi(false);
                          setPendingSubmit(null);
                          toast.success("Saldo awal berhasil disimpan!");
                          mutationData.mutate(param);
                          clearHandler();
                        },
                        onError: (error) => {
                          toast.error("Gagal menyimpan: " + (error.message || "Terjadi kesalahan"));
                        },
                      });
                    }}
                    ripple="light"
                  >
                    {mutationEdit.isLoading ? "Menyimpan..." : "Ya, Konfirmasi Simpan"}
                  </Button>
                )}
              </ModalFooter>
            </Modal>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SaldoAwal;
